import fr from 'facet-rest';
import BaseOverride from '../../../BaseOverride';

export default fr.metaOverride({ base: BaseOverride })
  .nameOverride(['moduleName', 'pretitle', 'title', 'subtitle', 'primaryText', 'secondaryText', 'additionalDetailTitle', 'additionalDetailItems'], {
    hidden: true,
  });
